import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

import { useFormikContext } from 'formik';
import { useObserver } from 'mobx-react';
import { useStore } from 'core/store/store.mobx';
import { Label } from 'core/components/label';
import DialogError from '../dialog-error';

const HomeOnly = ({ errors = [], rejections = [], classes }) => {
  const { values, resetForm } = useFormikContext();
  const { offer: store } = useStore();

  useEffect(() => {
    resetForm(values);
  }, []);

  return useObserver(() => (
    <>
      <Label type="titleSecondary" className={classes.title}>
        We can only offer Home policy
      </Label>
      <Label type="infoInnerTitle" className={classes.content}>
        There’s been an Auto policy rejection:
      </Label>
      {[...errors, ...rejections].map((error, index) => (
        <DialogError key={`${error.code}-${index}`} error={error} />
      ))}
      <Grid container alignItems="center" justifyContent="flex-end" className={classes.bottom}>
        <Button className={classes.link} variant="text" color="secondary" component={Link} to="/quote">
          Create new offer
        </Button>
        <Button
          onClick={() => store.triggerOfferDialog(false)}
          variant="contained"
          color="primary"
          className={classes.btn}
        >
          <Label className={classes.btnLabel}>Continue to current offer</Label>
        </Button>
      </Grid>
    </>
  ));
};

HomeOnly.propTypes = {
  errors: PropTypes.array.isRequired,
  rejections: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired
};

export default HomeOnly;
